module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/x.png?33e5b09e";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/x.png
// module id = 2379
// module chunks = 0